import React from 'react'
import TableSettings from './TableSettings'
import GameInfo from './GameInfo'
import { GAME_INFO, TABLE_SETTINGS, EXIT_TABLE_CONFIRM, LEAVE_SEAT_CONFIRM } from '@/Poker/data/Constants'
import Confirmation from '../Confirmation/Confirmation'

export default function GamePopups({ tempTableId, activeDrawer, setActiveDrawer }) {
    const isConfirmationPopup = [LEAVE_SEAT_CONFIRM, EXIT_TABLE_CONFIRM].includes(activeDrawer);

    return (
        <>
            <TableSettings tempTableId={tempTableId} open={activeDrawer === TABLE_SETTINGS} onOpenChange={setActiveDrawer} />
            <GameInfo tempTableId={tempTableId} open={activeDrawer === GAME_INFO} onOpenChange={setActiveDrawer} />
            <Confirmation activeDrawer={activeDrawer} tempTableId={tempTableId} open={isConfirmationPopup} onOpenChange={setActiveDrawer} />
        </>
    )
}
